import * as React from "react";
import { forwardRef } from "react";
const SvgPoliceSketch = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M5 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4m5 .85c-1.534 0-1.534 2.3 0 2.3h90v-2.3zM5 23a2 2 0 1 0 0 4 2 2 0 0 0 0-4m5 .85c-1.534 0-1.534 2.3 0 2.3h24.89a29 29 0 0 1 1.815-2.3zm67.33 0q.96 1.098 1.815 2.3H100v-2.3zM5 43a2 2 0 1 0 0 4 2 2 0 0 0 0-4m5 .85c-1.534 0-1.534 2.3 0 2.3h19.668a46 46 0 0 1-.125-2.3zm74.492 0c-.024.77-.062 1.537-.125 2.3H100v-2.3zM5 63a2 2 0 1 0 0 4 2 2 0 0 0 0-4m5 .85c-1.534 0-1.534 2.3 0 2.3h22.387c1.245-.635 2.496-1.27 3.74-1.888-.102-.136-.194-.276-.293-.412zm68.201 0c-.099.136-.191.276-.293.412a409 409 0 0 1 3.74 1.888H100v-2.3zM5 83a2 2 0 1 0 0 4 2 2 0 0 0 0-4m5 .85c-1.534 0-1.534 2.3 0 2.3h1.762q.444-1.18.916-2.3z" />
    <path d="M57.018 19.646c-10.86 0-21.653 9.294-22.182 22.762.012 9.53 2.713 17.466 10.182 23.385-7.922 3.773-18.127 8.94-23.881 12.89-2.718 4.867-6.797 14.08-7.102 21.317l42.983.074L100 100c-.306-7.238-4.383-16.45-7.102-21.316-5.754-3.951-15.958-9.118-23.88-12.891 7.468-5.919 10.169-13.855 10.181-23.385-.529-13.468-11.323-22.762-22.181-22.762" />
  </svg>
);
const ForwardRef = forwardRef(SvgPoliceSketch);
export default ForwardRef;
